import React, { useEffect, useState } from 'react'
import { frequencyFunnelBox } from 'src/Entities/ComplianceListViewEntity'
// import { Badge } from 'lucide-react'
import { Checkbox } from 'src/Common/ui/checkbox'
import PopoverMui from 'src/Common/ui/PopoverMui'
import TransferComplianceTable from './TransferComplianceTable'
import TransferBodyTable from './TransferBodyTable'
import { typePreviewTransferCondition } from 'src/Entities/TransferEntities'
import { FILTER_RESET, FILTER_SHOW_HIDE } from 'src/Entities/RiskTypes'
import CustomSearchField from 'src/Common/ui/searchInput'
import { cn } from 'src/lib/utils'
import { bodyPreview, transferBody } from 'src/Entities/CommonEntities'

function TransferComplainceContainer ({ type, setEntries, selectAll, setSelectAll, routePath, setCurrentPage, tempData, regulation, rowsPerPage, regulationTableData, transferTableSearchValue, handleEditClick, currentPage }) {
    const [ sortToggle, setSortToggle ] = useState(false)
    const [ paginatedData, setPaginatedData ] = useState([])
    // eslint-disable-next-line no-unused-vars
    const [ showTypeFilter, setShowTypeFilter ] = useState(null)
    const [ filteredRegulationData, setfilteredRegulationData ] = useState([])
    const [ typeFilter, setTypeFilter ] = useState([ ...frequencyFunnelBox, { label: FILTER_SHOW_HIDE, value: FILTER_SHOW_HIDE, checked: true, show: true }])
    useEffect(() => {
        setfilteredRegulationData(regulationTableData.filter(item => {
            if ((type === bodyPreview.NAME || type === transferBody.NAME)) {
                return item
            } else if (typeFilter.find(ele => (ele.checked && ele.value === item.frequencyName))) {
                return item
            }
            return null
        }).map(el => el))
    }, [ regulationTableData, transferTableSearchValue, typeFilter ])
    useEffect(() => {
        setPaginatedData(filteredRegulationData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
    }, [ filteredRegulationData, currentPage ])
    const handleTypeFilter = (event, item) => {
        setTypeFilter(typeFilter.map((ele) => {
            if (item === FILTER_RESET) {
                ele.checked = true
            }
            if (item === FILTER_SHOW_HIDE) {
                ele.checked = event
            } else if (ele.value === item) {
                ele.checked = !ele.checked
            }
            return ele
        }))
    }
    const sortFilter = (findOf) => {
        const sorted = [...filteredRegulationData].sort((a, b) => {
            if (typeof a[findOf] === 'string') {
                return sortToggle
                    ? b[findOf].localeCompare(a[findOf]) // Descending
                    : a[findOf].localeCompare(b[findOf]) // Ascending
            } else {
                return sortToggle ? b[findOf] - a[findOf] : a[findOf] - b[findOf] // Numeric sort
            }
        })
        setSortToggle(!sortToggle)
        setPaginatedData(sorted?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setfilteredRegulationData(sorted)
    }
    const sortFilterRaci = (findOf) => {
        const sorted = [...filteredRegulationData]?.sort((a, b) => {
            const userA = a.raciiMatrices[findOf]?.user ? a.raciiMatrices[findOf].user.toLowerCase() : ''
            const userB = b.raciiMatrices[findOf]?.user ? b.raciiMatrices[findOf].user.toLowerCase() : ''

            if (!sortToggle) {
                return userB.localeCompare(userA)
            } else {
                return userA.localeCompare(userB)
            }
        })

        setSortToggle(!sortToggle)
        setPaginatedData(sorted?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setfilteredRegulationData(sorted)
    }

    const handleTypeClick = (event) => {
        setShowTypeFilter(event.target)
    }

    useEffect(() => {
        if (transferTableSearchValue.length === 0) {
            setCurrentPage(1)
        }
        setEntries({
            entry: filteredRegulationData?.filter(ele => ele[typePreviewTransferCondition(type) ? 'regulationName' : 'complianceTitle']?.toLowerCase()?.includes(transferTableSearchValue)).length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + filteredRegulationData.filter(ele => ele[typePreviewTransferCondition(type) ? 'regulationName' : 'complianceTitle']?.toLowerCase()?.includes(transferTableSearchValue))?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)?.length - 1 + 1
        })
    }, [ filteredRegulationData, transferTableSearchValue ])
    useEffect(() => {
        setfilteredRegulationData(prevState => {
            return prevState?.map((item, i) => {
                item.checkbox = selectAll
                return item
            })
        })
    }, [selectAll])
    const handleSelectChecked = (id) => {
        setfilteredRegulationData(prevState => {
            return prevState.map((item, i) => {
                if (item.id === id) {
                    item.checkbox = !item.checkbox
                }
                return item
            })
        })
    }
    const handleSelectAll = (event) => {
        setSelectAll(event)
    }
    const [ typeFilterSearch, setTypeFilterSearch ] = useState('')
    const handleTypeFilterSearch = (e) => {
        setTypeFilterSearch(e)
    }
    const data = typeFilter.filter(ele => ele.label === FILTER_SHOW_HIDE || ele.label.toLowerCase().includes(typeFilterSearch))
    return (
        <>
            <PopoverMui id={2} anchorEl={showTypeFilter} setAnchorEl={setShowTypeFilter}>
                <CustomSearchField className={'w-[100%] p-1'} value={typeFilterSearch} setSearch={setTypeFilterSearch} onValueChange={handleTypeFilterSearch} />
                {
                    data.length === 1
                        ? <div className="flex justify-center h-full items-center p-4">
                            <div className="text-sm text-muted ">No Data</div>
                        </div>
                        : null
                }
                {
                    data?.map((item, i) => {
                        return (
                            <div key={i} className='p-4 flex items-center' >
                                <Checkbox
                                    checked={item.checked}
                                    onCheckedChange={(event) => handleTypeFilter(event, item.value)}
                                    className="mr-2"
                                    borderColor='text-primary'
                                    id={`${item.label}-${i}`}
                                />
                                <label htmlFor={`${item.label}-${i}`} className="cursor-pointer text-submenu !font-regular">{item?.label}</label>
                                {i === typeFilter?.length - 1 && <span className={cn(typeFilter.some(el => !el.checked) ? '' : 'pointer-events-none !text-grey', 'align-right text-sm ml-10 underline text-primary cursor-pointer')} onClick={() => handleTypeFilter('', FILTER_RESET)}>Reset</span>}

                            </div>
                        )
                    })
                }
            </PopoverMui>
            {
                typePreviewTransferCondition(type)
                    ? <TransferBodyTable
                        selectAll={selectAll}
                        handleSelectAll={handleSelectAll}
                        sortFilter={sortFilter}
                        sortFilterRaci={sortFilterRaci}
                        paginatedData={paginatedData}
                        handleTypeClick={handleTypeClick}
                        handleSelectChecked={handleSelectChecked}
                        transferTableSearchValue={transferTableSearchValue}
                        filteredRegulationData={filteredRegulationData}
                        currentPage={currentPage}
                        rowsPerPage={rowsPerPage}
                        type={type}
                    />
                    : <TransferComplianceTable
                        selectAll={selectAll}
                        handleSelectAll={handleSelectAll}
                        sortFilter={sortFilter}
                        paginatedData={paginatedData}
                        handleTypeClick={handleTypeClick}
                        handleSelectChecked={handleSelectChecked}
                        transferTableSearchValue={transferTableSearchValue}
                        filteredRegulationData={filteredRegulationData}
                        currentPage={currentPage}
                        rowsPerPage={rowsPerPage}
                        type={type}
                    />
            }
        </>
    )
}

export default TransferComplainceContainer
